export type ResponseBodyStream = ReadableStream<Uint8Array>;
export type StreamReader<T> = (body: ResponseBodyStream) => Promise<T>;

export const readStreamAsText = async (body: ResponseBodyStream) => {
  const reader = body.getReader();
  const stream = new ReadableStream({
    start(controller) {
      return pump();
      async function pump(): Promise<void> {
        const { done, value } = await reader.read();
        if (done) {
          controller.close();
          return;
        }
        controller.enqueue(value);
        return pump();
      }
    }
  });

  const newResponse = new Response(stream);
  const text = await newResponse.text();
  return text;
};
